export const PROJECTS_MATCH_TEMPLATE_ID = process.env.REACT_APP_PROJECTS_MATCH_TEMPLATE_ID;
export const MARKETPLACE_URL = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
export const WELCOME_TRAILS_TEMPLATE_ID = process.env.REACT_APP_WELCOME_TRAILS_TEMPLATE_ID;
export const TRIALS_INPROGRESS = process.env.REACT_APP_TRIALS_INPROGRESS_TEMPLATE_ID;

